export enum BeetweenAutomationEnum {
    NO_AUTOMATION = 'NO_AUTOMATION',
    AUTOMATION_ON_APPLICATION_CREATION = 'AUTOMATION_ON_APPLICATION_CREATION',
    AUTOMATION_ON_APPLICATION_AI_EVALUATION = 'AUTOMATION_ON_APPLICATION_AI_EVALUATION',
}

export class BeetweenAutomationEnumFunctions {
    static get selectItems() {
        return [
            { value: BeetweenAutomationEnum.NO_AUTOMATION, label: 'Pas d\'automatisation' },
            { value: BeetweenAutomationEnum.AUTOMATION_ON_APPLICATION_CREATION, label: 'Automatisation sur la création de candidatures' },
            { value: BeetweenAutomationEnum.AUTOMATION_ON_APPLICATION_AI_EVALUATION, label: 'Automatisation sur l\'évaluation de candidatures par l\'IA' },
        ];
    }
}
